import { render, staticRenderFns } from "./h5_Footer.vue?vue&type=template&id=8c0c8d68&scoped=true&"
import script from "./h5_Footer.vue?vue&type=script&lang=js&"
export * from "./h5_Footer.vue?vue&type=script&lang=js&"
import style0 from "./h5_Footer.vue?vue&type=style&index=0&id=8c0c8d68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0c8d68",
  null
  
)

export default component.exports